module.exports = __webpack_public_path__ + "static/media/portfolio.0816bfde.jpg";